import React, { useEffect, useState } from "react";

const WhatsappReplies = () => {
    const [replies, setReplies] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchReplies();
    }, []);

    const fetchReplies = async () => {
        try {
            const res = await fetch("/api/webhook/customers/whatsapp-replies");
            const data = await res.json();
            setReplies(data);
        } catch (err) {
            alert("Failed to load WhatsApp replies: " + err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 flex justify-center p-4">
            <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', backgroundColor: '#fff', zIndex: 1000, boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)', padding: '0px 0px', height: '60px', }} >
                <div className="w-full" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div className="title" onClick={() => (window.location.href = '/Marketing')} style={{ alignItems: 'left', marginLeft: '20px', paddingTop: '10px', cursor: 'pointer', display: 'flex' }} >
                        <img src="https://zordigo.com/assets/Logo2.png" className="w-10 h-auto" alt="Zordigo Logo" />
                        <b style={{ color: "#c1272c" }}>Zordigo</b>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'right', justifyContent: 'space-between', gap: '2px', marginRight: '20px' }}>
                        <div className="link-content" style={{ display: 'flex', alignItems: 'right', marginRight: '40px', cursor: 'pointer' }} title="Home Page" onClick={() => (window.location.href = '/Marketing')}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-arrow-left-square" viewBox="0 0 16 16" color="#c1272c" >
                                <path stroke="currentColor" strokeWidth="0.4" d="M8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4.5a.5.5 0 0 0 .5-.5v-4h2v4a.5.5 0 0 0 .5.5H14a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293zM2.5 14V7.707l5.5-5.5 5.5 5.5V14H10v-4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v4z" />
                            </svg>
                        </div>
                        <div className="link-content" style={{ display: 'flex', alignItems: 'right', marginRight: '40px', cursor: 'pointer' }} title="View Uploaded Data" onClick={() => (window.location.href = "/customer-data-list")} >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-table" viewBox="0 0 16 16" color="#c1272c" >
                                <path stroke="currentColor" strokeWidth="0.6" d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm15 2h-4v3h4zm0 4h-4v3h4zm0 4h-4v3h3a1 1 0 0 0 1-1zm-5 3v-3H6v3zm-5 0v-3H1v2a1 1 0 0 0 1 1zm-4-4h4V8H1zm0-4h4V4H1zm5-3v3h4V4zm4 4H6v3h4z" />
                            </svg>
                        </div>
                        <div className="link-content" style={{ display: 'flex', alignItems: 'right', marginRight: '40px', cursor: 'pointer' }} title="Log Out" onClick={() => (window.location.href = '/')} >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-box-arrow-right" viewBox="0 0 16 16" color="#c1272c" >
                                <path stroke="currentColor" strokeWidth="0.6" fill-rule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z" />
                                <path stroke="currentColor" strokeWidth="0.6" fill-rule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Panel */}
            < div className="w-full max-w-6xl bg-white rounded-2xl shadow-2xl border border-gray-200 p-8" style={{ marginTop: "90px" }}>
                {/* Header */}
                < header className="text-center mb-10" >
                    <h1 className="text-4xl font-bold text-gray-800">
                        Replies on WhatsApp from Distributors
                    </h1>
                </ header>

                {/* Table */}
                {
                    loading ? (
                        <p className="text-center text-gray-500">
                            Loading replies...
                        </p>
                    ) : replies.length === 0 ? (
                        <p className="text-center text-gray-500">
                            No WhatsApp replies received yet
                        </p>
                    ) : (
                        <div className="overflow-x-auto">
                            <table className="w-full border border-gray-200 rounded-lg">
                                <thead className="bg-gray-100">
                                    <tr>
                                        <th className="p-3 border">Name</th>
                                        <th className="p-3 border">Phone</th>
                                        <th className="p-3 border">Email</th>
                                        <th className="p-3 border">Message</th>
                                        <th className="p-3 border">Received At</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {replies.map((item) => (
                                        <tr
                                            key={item._id}
                                            className="hover:bg-gray-50 transition"
                                        >
                                            <td className="p-3 border">
                                                {item.customer_name}
                                            </td>
                                            <td className="p-3 border">
                                                {item.customer_phone}
                                            </td>
                                            <td className="p-3 border">
                                                {item.customer_email}
                                            </td>
                                            <td className="p-3 border">
                                                {item.last_whatsapp_reply}
                                            </td>
                                            <td className="p-3 border">
                                                {new Date(
                                                    item.last_whatsapp_reply_at
                                                ).toLocaleString()}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )
                }
            </div>
        </div>
    );
};

export default WhatsappReplies;
